export const ROUTES = {
  home: '/',
  safety: '/safety-compliance/',
  safetyLegacy: '/safety',
  safetyVictoria: '/safety-compliance/victoria/',
  safetyNewSouthWales: '/safety-compliance/new-south-wales/',
  safetyQueensland: '/safety-compliance/queensland/',
  safetySouthAustralia: '/safety-compliance/south-australia/',
  tradies: '/tradies/',
  homeModifications: '/home-modifications/',
  energyRebates: '/energy-rebates/',
  energyRebatesAirConditioning: '/energy-rebates/air-conditioning/',
  energyRebatesHotWater: '/energy-rebates/heat-pump-hot-water/',
  energyRebatesInsulation: '/energy-rebates/ceiling-insulation/',
  energyRebatesShowerHeads: '/energy-rebates/shower-heads/',
  contact: '/contact/',
  careers: '/careers/',
  careersSmokeAlarmTechnician: '/careers/smoke-alarm-technician/',
  careersElectrician: '/careers/electrician/',
  careersElectricianQueensland: '/careers/electrician-qld/',
  careersElectricianVictoria: '/careers/electrician-vic/',
  careersPlumber: '/careers/plumber/',
  privacyPolicy: '/privacy-policy/',
  termsAndConditions: '/terms-and-conditions/',
};

export const SITE_ORIGIN = 'https://mylo.com.au';

export const canonical = (route) => `${SITE_ORIGIN}${route}`;
